/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetPermissionsQueryResponse, HierarchiesControllerGetPermissionsPathParams, HierarchiesControllerGetPermissionsQueryParams, HierarchiesControllerGetPermissions401, HierarchiesControllerGetPermissions403 } from "../../models/hierarchiesController/HierarchiesControllerGetPermissions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { hierarchiesControllerGetPermissions } from "../../clients/hierarchiesService/hierarchiesControllerGetPermissions";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const hierarchiesControllerGetPermissionsQueryKey = (scopeId: HierarchiesControllerGetPermissionsPathParams["scopeId"], params: HierarchiesControllerGetPermissionsQueryParams) => [{
  url: '/api/v1/hierarchies/:scopeId/permissions',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type HierarchiesControllerGetPermissionsQueryKey = ReturnType<typeof hierarchiesControllerGetPermissionsQueryKey>;
export function hierarchiesControllerGetPermissionsQueryOptions(scopeId: HierarchiesControllerGetPermissionsPathParams["scopeId"], params: HierarchiesControllerGetPermissionsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = hierarchiesControllerGetPermissionsQueryKey(scopeId, params);
  return queryOptions<HierarchiesControllerGetPermissionsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetPermissions401 | HierarchiesControllerGetPermissions403>, HierarchiesControllerGetPermissionsQueryResponse, typeof queryKey>({
    enabled: !!(scopeId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return hierarchiesControllerGetPermissions(scopeId, params, config);
    }
  });
}

/**
 * @description Get all effective permissions for the current user in the scope hierarchy
 * @summary Get effective permissions
 * {@link /api/v1/hierarchies/:scopeId/permissions}
 */
export function useHierarchiesControllerGetPermissions<TData = HierarchiesControllerGetPermissionsQueryResponse, TQueryData = HierarchiesControllerGetPermissionsQueryResponse, TQueryKey extends QueryKey = HierarchiesControllerGetPermissionsQueryKey>(scopeId: HierarchiesControllerGetPermissionsPathParams["scopeId"], params: HierarchiesControllerGetPermissionsQueryParams, options: {
  query?: Partial<QueryObserverOptions<HierarchiesControllerGetPermissionsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetPermissions401 | HierarchiesControllerGetPermissions403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? hierarchiesControllerGetPermissionsQueryKey(scopeId, params);
  const query = useQuery({
    ...hierarchiesControllerGetPermissionsQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<HierarchiesControllerGetPermissions401 | HierarchiesControllerGetPermissions403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}